export default __webpack_public_path__ + "static/media/bar-company-profile.cebaf6b3.svg";